import api from '@/services/api'

export default class TagAPI {
  static TAGS_ENDPOINT = 'tags'
  /**
   * Initialize a `TagAPI` instance.
   *
   * @param {class} cls  The class to use to create tag objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `TagAPI`.
   *
   * @param {class} cls      The class to use to create tag objects.
   **/
  static create(cls) {
    return new TagAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one tag from the API.
   *
   * @param {String} TagID  Unique ID of the tag to retrieve.
   */
  get(TagID) {
    const url = `${TagAPI.TAGS_ENDPOINT}/${TagID}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Get all tags through the API.
   *
   *
   */
  // eslint-disable-next-line no-unused-vars
  list({ filters = {} } = {}) {
    const url = `${TagAPI.TAGS_ENDPOINT}/`
    const options = {
      params: {},
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => {
        // To Do, add data.results instead of data when you add pagination
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
  }

  /**
   * Update a tag through the API.
   *
   * @param {Tag} Tag data to send to the API.
   */
  update(tag, fields = [], excludeFields = []) {
    const url = `${TagAPI.TAGS_ENDPOINT}/${tag.id}/`
    const data = this.cls.toAPI(tag, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }
}
